var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.07 330",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1263a9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hide password") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,436a10,10,0,0,0,10-10V366a10,10,0,0,0-20,0v60A10,10,0,0,0,256,436Z",
    transform: "translate(0.03 -106)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.7,343.9l42.4,42.4a10,10,0,0,0,14.1-14.1l-42.4-42.4a10,10,0,0,0-14.1,14.1Z",
    transform: "translate(0.03 -106)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.7,386.3a10,10,0,0,0,14.1,0l42.4-42.4a10,10,0,0,0-14.1-14.1L87.7,372.2A10,10,0,0,0,87.7,386.3Z",
    transform: "translate(0.03 -106)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.5,234.3C66,306.2,160.4,366,256,366s190-59.8,253.5-131.7a10,10,0,1,0-15-13.2c-2.1,2.4-4.3,4.8-6.5,7.2C438.6,153.6,349,106,256,106S73.4,153.6,24,228.3c-2.2-2.4-4.4-4.8-6.5-7.2a10.07,10.07,0,0,0-14.1-.9A9.89,9.89,0,0,0,2.5,234.3ZM256,126c87.9,0,172.5,45.7,217.7,117-35.6,34.9-118,103-217.7,103S73.9,277.9,38.3,243C83.5,171.7,168.1,126,256,126Z",
    transform: "translate(0.03 -106)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show_password.57e4adf9a4f8b5bf556fdc8be2fa8de8.svg";
export { ForwardRef as ReactComponent };